import styled from 'styled-components'
import { Box } from '@dasa-health/components-react'

export const Container = styled.div`
    position: relative;
    width: 100%;
    background-color: #0037ff;
    display: flex;
    padding: 3rem 1rem;
`

export const Img = styled.img`
    position: absolute;
    right: 15%;
    top: -2rem;
    width: 19rem;
    height: 30rem;

    @media (max-width: 90rem) {
        right: 5%;
    }

    @media (max-width: 52.5rem) {
        display: none;
    }
`

export const Content = styled.div`
    margin: 0 auto;
    max-width: 54rem;
    width: 100%;

    @media (max-width: 52.5rem) {
        max-width: 38rem;
    }
`

export const TextBox = styled.div`
    max-width: 30rem;
`

export const Title = styled.p`
    color: #fefefe;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
`

export const Paragraph = styled.p`
    color: #e9e9e9;
    margin-top: 2rem;
`

export const ButtonsBox = styled(Box)`
    display: flex;
    gap: 1.5rem;
    margin-top: 4rem !important;

    button {
        background-color: #fefefe;
        color: #0037ff;
        width: 12.5rem;
        border-radius: 8px;
    }

    button:hover,
    button:focus,
    button:active {
        background-color: #eee !important;
    }

    @media (max-width: 28.5rem) {
        flex-direction: column;
        margin-top: 2.5rem !important;

        button {
            width: 100%;
        }
    }
`
